"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.find-index.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _activityIndicator = _interopRequireDefault(require("@gravity/activity-indicator"));
var _advantageCode = _interopRequireDefault(require("@gravity/advantage-code"));
var _button = require("@gravity/button");
var _message = _interopRequireWildcard(require("@gravity/message"));
var _reportManagement = _interopRequireDefault(require("@gravity/report-management"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _tabs = require("@gravity/tabs");
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _filter = require("@nucleo/filter");
var _productList2 = require("@nucleo/product-list");
var _section = require("@nucleo/section");
var _get = _interopRequireDefault(require("lodash/get"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _size = _interopRequireDefault(require("lodash/size"));
var _SectionProducts = _interopRequireDefault(require("./SectionProducts"));
var _TabFilterBar = _interopRequireDefault(require("./TabFilterBar"));
var _helper = require("./helper");
var _skeleton = _interopRequireDefault(require("@gravity/skeleton"));
var _jsxFileName = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/ProductList.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_pkh9at0g0() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/ProductList.js";
  var hash = "f4f2d715dc5d043d7f2bb8fe4a3ca13aa3bc245f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/ProductList.js",
    statementMap: {
      "0": {
        start: {
          line: 41,
          column: 34
        },
        end: {
          line: 41,
          column: 50
        }
      },
      "1": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 219,
          column: 1
        }
      },
      "2": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      "3": {
        start: {
          line: 75,
          column: 37
        },
        end: {
          line: 75,
          column: 94
        }
      },
      "4": {
        start: {
          line: 81,
          column: 39
        },
        end: {
          line: 81,
          column: 90
        }
      },
      "5": {
        start: {
          line: 126,
          column: 41
        },
        end: {
          line: 126,
          column: 86
        }
      },
      "6": {
        start: {
          line: 171,
          column: 43
        },
        end: {
          line: 171,
          column: 88
        }
      },
      "7": {
        start: {
          line: 221,
          column: 19
        },
        end: {
          line: 223,
          column: 1
        }
      },
      "8": {
        start: {
          line: 225,
          column: 28
        },
        end: {
          line: 227,
          column: 4
        }
      },
      "9": {
        start: {
          line: 229,
          column: 30
        },
        end: {
          line: 229,
          column: 48
        }
      },
      "10": {
        start: {
          line: 231,
          column: 23
        },
        end: {
          line: 236,
          column: 1
        }
      },
      "11": {
        start: {
          line: 238,
          column: 23
        },
        end: {
          line: 243,
          column: 1
        }
      },
      "12": {
        start: {
          line: 245,
          column: 25
        },
        end: {
          line: 264,
          column: 2
        }
      },
      "13": {
        start: {
          line: 266,
          column: 33
        },
        end: {
          line: 293,
          column: 1
        }
      },
      "14": {
        start: {
          line: 274,
          column: 39
        },
        end: {
          line: 274,
          column: 72
        }
      },
      "15": {
        start: {
          line: 282,
          column: 6
        },
        end: {
          line: 287,
          column: 7
        }
      },
      "16": {
        start: {
          line: 295,
          column: 35
        },
        end: {
          line: 295,
          column: 80
        }
      },
      "17": {
        start: {
          line: 298,
          column: 36
        },
        end: {
          line: 310,
          column: 3
        }
      },
      "18": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 308,
          column: 5
        }
      },
      "19": {
        start: {
          line: 301,
          column: 31
        },
        end: {
          line: 303,
          column: 7
        }
      },
      "20": {
        start: {
          line: 302,
          column: 15
        },
        end: {
          line: 302,
          column: 48
        }
      },
      "21": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 307,
          column: 8
        }
      },
      "22": {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 309,
          column: 16
        }
      },
      "23": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 17
        }
      },
      "24": {
        start: {
          line: 314,
          column: 40
        },
        end: {
          line: 314,
          column: 45
        }
      },
      "25": {
        start: {
          line: 315,
          column: 29
        },
        end: {
          line: 317,
          column: 5
        }
      },
      "26": {
        start: {
          line: 316,
          column: 13
        },
        end: {
          line: 316,
          column: 36
        }
      },
      "27": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 323,
          column: 6
        }
      },
      "28": {
        start: {
          line: 328,
          column: 6
        },
        end: {
          line: 329,
          column: 65
        }
      },
      "29": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 394,
          column: 5
        }
      },
      "30": {
        start: {
          line: 331,
          column: 31
        },
        end: {
          line: 331,
          column: 64
        }
      },
      "31": {
        start: {
          line: 332,
          column: 6
        },
        end: {
          line: 332,
          column: 48
        }
      },
      "32": {
        start: {
          line: 333,
          column: 35
        },
        end: {
          line: 333,
          column: 45
        }
      },
      "33": {
        start: {
          line: 334,
          column: 19
        },
        end: {
          line: 334,
          column: 58
        }
      },
      "34": {
        start: {
          line: 335,
          column: 27
        },
        end: {
          line: 338,
          column: 8
        }
      },
      "35": {
        start: {
          line: 339,
          column: 39
        },
        end: {
          line: 339,
          column: 51
        }
      },
      "36": {
        start: {
          line: 342,
          column: 29
        },
        end: {
          line: 350,
          column: 7
        }
      },
      "37": {
        start: {
          line: 344,
          column: 10
        },
        end: {
          line: 349,
          column: 11
        }
      },
      "38": {
        start: {
          line: 346,
          column: 14
        },
        end: {
          line: 348,
          column: 43
        }
      },
      "39": {
        start: {
          line: 352,
          column: 6
        },
        end: {
          line: 366,
          column: 7
        }
      },
      "40": {
        start: {
          line: 353,
          column: 8
        },
        end: {
          line: 361,
          column: 9
        }
      },
      "41": {
        start: {
          line: 355,
          column: 25
        },
        end: {
          line: 355,
          column: 26
        }
      },
      "42": {
        start: {
          line: 356,
          column: 10
        },
        end: {
          line: 360,
          column: 13
        }
      },
      "43": {
        start: {
          line: 358,
          column: 12
        },
        end: {
          line: 358,
          column: 40
        }
      },
      "44": {
        start: {
          line: 359,
          column: 12
        },
        end: {
          line: 359,
          column: 26
        }
      },
      "45": {
        start: {
          line: 362,
          column: 8
        },
        end: {
          line: 364,
          column: 10
        }
      },
      "46": {
        start: {
          line: 365,
          column: 8
        },
        end: {
          line: 365,
          column: 52
        }
      },
      "47": {
        start: {
          line: 370,
          column: 30
        },
        end: {
          line: 370,
          column: 31
        }
      },
      "48": {
        start: {
          line: 371,
          column: 6
        },
        end: {
          line: 376,
          column: 9
        }
      },
      "49": {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 375,
          column: 9
        }
      },
      "50": {
        start: {
          line: 373,
          column: 10
        },
        end: {
          line: 373,
          column: 69
        }
      },
      "51": {
        start: {
          line: 374,
          column: 10
        },
        end: {
          line: 374,
          column: 33
        }
      },
      "52": {
        start: {
          line: 378,
          column: 31
        },
        end: {
          line: 386,
          column: 7
        }
      },
      "53": {
        start: {
          line: 380,
          column: 10
        },
        end: {
          line: 385,
          column: 11
        }
      },
      "54": {
        start: {
          line: 382,
          column: 14
        },
        end: {
          line: 384,
          column: 45
        }
      },
      "55": {
        start: {
          line: 388,
          column: 6
        },
        end: {
          line: 393,
          column: 7
        }
      },
      "56": {
        start: {
          line: 389,
          column: 8
        },
        end: {
          line: 391,
          column: 10
        }
      },
      "57": {
        start: {
          line: 392,
          column: 8
        },
        end: {
          line: 392,
          column: 56
        }
      },
      "58": {
        start: {
          line: 397,
          column: 23
        },
        end: {
          line: 402,
          column: 3
        }
      },
      "59": {
        start: {
          line: 398,
          column: 4
        },
        end: {
          line: 400,
          column: 7
        }
      },
      "60": {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 401,
          column: 36
        }
      },
      "61": {
        start: {
          line: 404,
          column: 20
        },
        end: {
          line: 413,
          column: 3
        }
      },
      "62": {
        start: {
          line: 406,
          column: 4
        },
        end: {
          line: 412,
          column: 6
        }
      },
      "63": {
        start: {
          line: 415,
          column: 18
        },
        end: {
          line: 424,
          column: 3
        }
      },
      "64": {
        start: {
          line: 417,
          column: 4
        },
        end: {
          line: 423,
          column: 6
        }
      },
      "65": {
        start: {
          line: 426,
          column: 21
        },
        end: {
          line: 437,
          column: 3
        }
      },
      "66": {
        start: {
          line: 427,
          column: 4
        },
        end: {
          line: 429,
          column: 5
        }
      },
      "67": {
        start: {
          line: 428,
          column: 6
        },
        end: {
          line: 428,
          column: 18
        }
      },
      "68": {
        start: {
          line: 430,
          column: 27
        },
        end: {
          line: 432,
          column: 44
        }
      },
      "69": {
        start: {
          line: 431,
          column: 25
        },
        end: {
          line: 431,
          column: 46
        }
      },
      "70": {
        start: {
          line: 432,
          column: 22
        },
        end: {
          line: 432,
          column: 43
        }
      },
      "71": {
        start: {
          line: 433,
          column: 4
        },
        end: {
          line: 435,
          column: 5
        }
      },
      "72": {
        start: {
          line: 434,
          column: 6
        },
        end: {
          line: 434,
          column: 31
        }
      },
      "73": {
        start: {
          line: 436,
          column: 4
        },
        end: {
          line: 436,
          column: 16
        }
      },
      "74": {
        start: {
          line: 442,
          column: 34
        },
        end: {
          line: 451,
          column: 3
        }
      },
      "75": {
        start: {
          line: 443,
          column: 20
        },
        end: {
          line: 443,
          column: 66
        }
      },
      "76": {
        start: {
          line: 443,
          column: 45
        },
        end: {
          line: 443,
          column: 65
        }
      },
      "77": {
        start: {
          line: 444,
          column: 4
        },
        end: {
          line: 446,
          column: 5
        }
      },
      "78": {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 445,
          column: 23
        }
      },
      "79": {
        start: {
          line: 447,
          column: 30
        },
        end: {
          line: 449,
          column: 5
        }
      },
      "80": {
        start: {
          line: 448,
          column: 17
        },
        end: {
          line: 448,
          column: 27
        }
      },
      "81": {
        start: {
          line: 450,
          column: 4
        },
        end: {
          line: 450,
          column: 38
        }
      },
      "82": {
        start: {
          line: 453,
          column: 16
        },
        end: {
          line: 468,
          column: 3
        }
      },
      "83": {
        start: {
          line: 454,
          column: 4
        },
        end: {
          line: 467,
          column: 5
        }
      },
      "84": {
        start: {
          line: 456,
          column: 38
        },
        end: {
          line: 456,
          column: 85
        }
      },
      "85": {
        start: {
          line: 457,
          column: 8
        },
        end: {
          line: 457,
          column: 49
        }
      },
      "86": {
        start: {
          line: 458,
          column: 8
        },
        end: {
          line: 458,
          column: 14
        }
      },
      "87": {
        start: {
          line: 461,
          column: 40
        },
        end: {
          line: 461,
          column: 89
        }
      },
      "88": {
        start: {
          line: 462,
          column: 8
        },
        end: {
          line: 462,
          column: 51
        }
      },
      "89": {
        start: {
          line: 463,
          column: 8
        },
        end: {
          line: 463,
          column: 14
        }
      },
      "90": {
        start: {
          line: 466,
          column: 8
        },
        end: {
          line: 466,
          column: 14
        }
      },
      "91": {
        start: {
          line: 470,
          column: 28
        },
        end: {
          line: 475,
          column: 7
        }
      },
      "92": {
        start: {
          line: 471,
          column: 4
        },
        end: {
          line: 475,
          column: 7
        }
      },
      "93": {
        start: {
          line: 471,
          column: 37
        },
        end: {
          line: 475,
          column: 5
        }
      },
      "94": {
        start: {
          line: 480,
          column: 30
        },
        end: {
          line: 492,
          column: 3
        }
      },
      "95": {
        start: {
          line: 482,
          column: 4
        },
        end: {
          line: 484,
          column: 5
        }
      },
      "96": {
        start: {
          line: 483,
          column: 6
        },
        end: {
          line: 483,
          column: 16
        }
      },
      "97": {
        start: {
          line: 485,
          column: 4
        },
        end: {
          line: 491,
          column: 6
        }
      },
      "98": {
        start: {
          line: 490,
          column: 8
        },
        end: {
          line: 490,
          column: 86
        }
      },
      "99": {
        start: {
          line: 494,
          column: 21
        },
        end: {
          line: 495,
          column: 91
        }
      },
      "100": {
        start: {
          line: 495,
          column: 4
        },
        end: {
          line: 495,
          column: 91
        }
      },
      "101": {
        start: {
          line: 497,
          column: 26
        },
        end: {
          line: 505,
          column: 3
        }
      },
      "102": {
        start: {
          line: 498,
          column: 4
        },
        end: {
          line: 500,
          column: 5
        }
      },
      "103": {
        start: {
          line: 499,
          column: 6
        },
        end: {
          line: 499,
          column: 19
        }
      },
      "104": {
        start: {
          line: 501,
          column: 20
        },
        end: {
          line: 501,
          column: 49
        }
      },
      "105": {
        start: {
          line: 504,
          column: 4
        },
        end: {
          line: 504,
          column: 77
        }
      },
      "106": {
        start: {
          line: 529,
          column: 8
        },
        end: {
          line: 529,
          column: 18
        }
      },
      "107": {
        start: {
          line: 531,
          column: 17
        },
        end: {
          line: 531,
          column: 33
        }
      },
      "108": {
        start: {
          line: 532,
          column: 33
        },
        end: {
          line: 532,
          column: 43
        }
      },
      "109": {
        start: {
          line: 533,
          column: 27
        },
        end: {
          line: 533,
          column: 54
        }
      },
      "110": {
        start: {
          line: 536,
          column: 6
        },
        end: {
          line: 538,
          column: 12
        }
      },
      "111": {
        start: {
          line: 541,
          column: 24
        },
        end: {
          line: 541,
          column: 28
        }
      },
      "112": {
        start: {
          line: 542,
          column: 4
        },
        end: {
          line: 557,
          column: 5
        }
      },
      "113": {
        start: {
          line: 543,
          column: 35
        },
        end: {
          line: 543,
          column: 57
        }
      },
      "114": {
        start: {
          line: 544,
          column: 6
        },
        end: {
          line: 556,
          column: 17
        }
      },
      "115": {
        start: {
          line: 565,
          column: 8
        },
        end: {
          line: 565,
          column: 18
        }
      },
      "116": {
        start: {
          line: 567,
          column: 29
        },
        end: {
          line: 597,
          column: 5
        }
      },
      "117": {
        start: {
          line: 569,
          column: 6
        },
        end: {
          line: 571,
          column: 7
        }
      },
      "118": {
        start: {
          line: 570,
          column: 8
        },
        end: {
          line: 570,
          column: 20
        }
      },
      "119": {
        start: {
          line: 572,
          column: 26
        },
        end: {
          line: 572,
          column: 30
        }
      },
      "120": {
        start: {
          line: 573,
          column: 34
        },
        end: {
          line: 576,
          column: 7
        }
      },
      "121": {
        start: {
          line: 577,
          column: 31
        },
        end: {
          line: 577,
          column: 94
        }
      },
      "122": {
        start: {
          line: 579,
          column: 8
        },
        end: {
          line: 579,
          column: 93
        }
      },
      "123": {
        start: {
          line: 581,
          column: 6
        },
        end: {
          line: 583,
          column: 7
        }
      },
      "124": {
        start: {
          line: 582,
          column: 8
        },
        end: {
          line: 582,
          column: 98
        }
      },
      "125": {
        start: {
          line: 582,
          column: 75
        },
        end: {
          line: 582,
          column: 95
        }
      },
      "126": {
        start: {
          line: 584,
          column: 6
        },
        end: {
          line: 596,
          column: 8
        }
      },
      "127": {
        start: {
          line: 599,
          column: 34
        },
        end: {
          line: 602,
          column: 5
        }
      },
      "128": {
        start: {
          line: 604,
          column: 20
        },
        end: {
          line: 604,
          column: 26
        }
      },
      "129": {
        start: {
          line: 606,
          column: 28
        },
        end: {
          line: 612,
          column: 8
        }
      },
      "130": {
        start: {
          line: 607,
          column: 6
        },
        end: {
          line: 609,
          column: 7
        }
      },
      "131": {
        start: {
          line: 608,
          column: 8
        },
        end: {
          line: 608,
          column: 40
        }
      },
      "132": {
        start: {
          line: 611,
          column: 6
        },
        end: {
          line: 611,
          column: 28
        }
      },
      "133": {
        start: {
          line: 614,
          column: 23
        },
        end: {
          line: 614,
          column: 77
        }
      },
      "134": {
        start: {
          line: 616,
          column: 4
        },
        end: {
          line: 694,
          column: 6
        }
      },
      "135": {
        start: {
          line: 633,
          column: 12
        },
        end: {
          line: 690,
          column: 18
        }
      },
      "136": {
        start: {
          line: 661,
          column: 18
        },
        end: {
          line: 682,
          column: 20
        }
      },
      "137": {
        start: {
          line: 698,
          column: 0
        },
        end: {
          line: 749,
          column: 2
        }
      },
      "138": {
        start: {
          line: 751,
          column: 0
        },
        end: {
          line: 777,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 45,
            column: 16
          }
        },
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 8
          }
        },
        line: 46
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 75,
            column: 28
          },
          end: {
            line: 75,
            column: 29
          }
        },
        loc: {
          start: {
            line: 75,
            column: 37
          },
          end: {
            line: 75,
            column: 94
          }
        },
        line: 75
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 81,
            column: 30
          },
          end: {
            line: 81,
            column: 31
          }
        },
        loc: {
          start: {
            line: 81,
            column: 39
          },
          end: {
            line: 81,
            column: 90
          }
        },
        line: 81
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 126,
            column: 32
          },
          end: {
            line: 126,
            column: 33
          }
        },
        loc: {
          start: {
            line: 126,
            column: 41
          },
          end: {
            line: 126,
            column: 86
          }
        },
        line: 126
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 171,
            column: 34
          },
          end: {
            line: 171,
            column: 35
          }
        },
        loc: {
          start: {
            line: 171,
            column: 43
          },
          end: {
            line: 171,
            column: 88
          }
        },
        line: 171
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 274,
            column: 24
          },
          end: {
            line: 274,
            column: 25
          }
        },
        loc: {
          start: {
            line: 274,
            column: 39
          },
          end: {
            line: 274,
            column: 72
          }
        },
        line: 274
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 281,
            column: 6
          },
          end: {
            line: 281,
            column: 7
          }
        },
        loc: {
          start: {
            line: 282,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        },
        line: 282
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 298,
            column: 36
          },
          end: {
            line: 298,
            column: 37
          }
        },
        loc: {
          start: {
            line: 298,
            column: 58
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 298
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 302,
            column: 9
          }
        },
        loc: {
          start: {
            line: 302,
            column: 15
          },
          end: {
            line: 302,
            column: 48
          }
        },
        line: 302
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 312,
            column: 3
          }
        },
        loc: {
          start: {
            line: 312,
            column: 21
          },
          end: {
            line: 324,
            column: 3
          }
        },
        line: 312
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 316,
            column: 6
          },
          end: {
            line: 316,
            column: 7
          }
        },
        loc: {
          start: {
            line: 316,
            column: 13
          },
          end: {
            line: 316,
            column: 36
          }
        },
        line: 316
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 326,
            column: 3
          }
        },
        loc: {
          start: {
            line: 326,
            column: 43
          },
          end: {
            line: 395,
            column: 3
          }
        },
        line: 326
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 343,
            column: 8
          },
          end: {
            line: 343,
            column: 9
          }
        },
        loc: {
          start: {
            line: 344,
            column: 10
          },
          end: {
            line: 349,
            column: 11
          }
        },
        line: 344
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 345,
            column: 12
          },
          end: {
            line: 345,
            column: 13
          }
        },
        loc: {
          start: {
            line: 346,
            column: 14
          },
          end: {
            line: 348,
            column: 43
          }
        },
        line: 346
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 356,
            column: 33
          },
          end: {
            line: 356,
            column: 34
          }
        },
        loc: {
          start: {
            line: 356,
            column: 44
          },
          end: {
            line: 360,
            column: 11
          }
        },
        line: 356
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 371,
            column: 38
          },
          end: {
            line: 371,
            column: 39
          }
        },
        loc: {
          start: {
            line: 371,
            column: 45
          },
          end: {
            line: 376,
            column: 7
          }
        },
        line: 371
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 379,
            column: 8
          },
          end: {
            line: 379,
            column: 9
          }
        },
        loc: {
          start: {
            line: 380,
            column: 10
          },
          end: {
            line: 385,
            column: 11
          }
        },
        line: 380
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 381,
            column: 12
          },
          end: {
            line: 381,
            column: 13
          }
        },
        loc: {
          start: {
            line: 382,
            column: 14
          },
          end: {
            line: 384,
            column: 45
          }
        },
        line: 382
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 397,
            column: 23
          },
          end: {
            line: 397,
            column: 24
          }
        },
        loc: {
          start: {
            line: 397,
            column: 43
          },
          end: {
            line: 402,
            column: 3
          }
        },
        line: 397
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 404,
            column: 20
          },
          end: {
            line: 404,
            column: 21
          }
        },
        loc: {
          start: {
            line: 404,
            column: 38
          },
          end: {
            line: 413,
            column: 3
          }
        },
        line: 404
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 415,
            column: 18
          },
          end: {
            line: 415,
            column: 19
          }
        },
        loc: {
          start: {
            line: 415,
            column: 29
          },
          end: {
            line: 424,
            column: 3
          }
        },
        line: 415
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 426,
            column: 21
          },
          end: {
            line: 426,
            column: 22
          }
        },
        loc: {
          start: {
            line: 426,
            column: 32
          },
          end: {
            line: 437,
            column: 3
          }
        },
        line: 426
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 431,
            column: 14
          },
          end: {
            line: 431,
            column: 15
          }
        },
        loc: {
          start: {
            line: 431,
            column: 25
          },
          end: {
            line: 431,
            column: 46
          }
        },
        line: 431
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 432,
            column: 11
          },
          end: {
            line: 432,
            column: 12
          }
        },
        loc: {
          start: {
            line: 432,
            column: 22
          },
          end: {
            line: 432,
            column: 43
          }
        },
        line: 432
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 442,
            column: 34
          },
          end: {
            line: 442,
            column: 35
          }
        },
        loc: {
          start: {
            line: 442,
            column: 66
          },
          end: {
            line: 451,
            column: 3
          }
        },
        line: 442
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 443,
            column: 38
          },
          end: {
            line: 443,
            column: 39
          }
        },
        loc: {
          start: {
            line: 443,
            column: 45
          },
          end: {
            line: 443,
            column: 65
          }
        },
        line: 443
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 448,
            column: 6
          },
          end: {
            line: 448,
            column: 7
          }
        },
        loc: {
          start: {
            line: 448,
            column: 17
          },
          end: {
            line: 448,
            column: 27
          }
        },
        line: 448
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 453,
            column: 16
          },
          end: {
            line: 453,
            column: 17
          }
        },
        loc: {
          start: {
            line: 453,
            column: 37
          },
          end: {
            line: 468,
            column: 3
          }
        },
        line: 453
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 470,
            column: 28
          },
          end: {
            line: 470,
            column: 29
          }
        },
        loc: {
          start: {
            line: 471,
            column: 4
          },
          end: {
            line: 475,
            column: 7
          }
        },
        line: 471
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 471,
            column: 25
          },
          end: {
            line: 471,
            column: 26
          }
        },
        loc: {
          start: {
            line: 471,
            column: 37
          },
          end: {
            line: 475,
            column: 5
          }
        },
        line: 471
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 480,
            column: 30
          },
          end: {
            line: 480,
            column: 31
          }
        },
        loc: {
          start: {
            line: 480,
            column: 81
          },
          end: {
            line: 492,
            column: 3
          }
        },
        line: 480
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 489,
            column: 29
          },
          end: {
            line: 489,
            column: 30
          }
        },
        loc: {
          start: {
            line: 490,
            column: 8
          },
          end: {
            line: 490,
            column: 86
          }
        },
        line: 490
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 494,
            column: 21
          },
          end: {
            line: 494,
            column: 22
          }
        },
        loc: {
          start: {
            line: 495,
            column: 4
          },
          end: {
            line: 495,
            column: 91
          }
        },
        line: 495
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 497,
            column: 26
          },
          end: {
            line: 497,
            column: 27
          }
        },
        loc: {
          start: {
            line: 497,
            column: 38
          },
          end: {
            line: 505,
            column: 3
          }
        },
        line: 497
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 507,
            column: 2
          },
          end: {
            line: 507,
            column: 3
          }
        },
        loc: {
          start: {
            line: 507,
            column: 11
          },
          end: {
            line: 695,
            column: 3
          }
        },
        line: 507
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 567,
            column: 29
          },
          end: {
            line: 567,
            column: 30
          }
        },
        loc: {
          start: {
            line: 567,
            column: 40
          },
          end: {
            line: 597,
            column: 5
          }
        },
        line: 567
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 582,
            column: 68
          },
          end: {
            line: 582,
            column: 69
          }
        },
        loc: {
          start: {
            line: 582,
            column: 75
          },
          end: {
            line: 582,
            column: 95
          }
        },
        line: 582
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 606,
            column: 29
          },
          end: {
            line: 606,
            column: 30
          }
        },
        loc: {
          start: {
            line: 606,
            column: 35
          },
          end: {
            line: 612,
            column: 5
          }
        },
        line: 606
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 632,
            column: 20
          },
          end: {
            line: 632,
            column: 21
          }
        },
        loc: {
          start: {
            line: 633,
            column: 12
          },
          end: {
            line: 690,
            column: 18
          }
        },
        line: 633
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 660,
            column: 34
          },
          end: {
            line: 660,
            column: 35
          }
        },
        loc: {
          start: {
            line: 661,
            column: 18
          },
          end: {
            line: 682,
            column: 20
          }
        },
        line: 661
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 760,
            column: 19
          },
          end: {
            line: 760,
            column: 20
          }
        },
        loc: {
          start: {
            line: 760,
            column: 25
          },
          end: {
            line: 760,
            column: 27
          }
        },
        line: 760
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 761,
            column: 17
          },
          end: {
            line: 761,
            column: 18
          }
        },
        loc: {
          start: {
            line: 761,
            column: 23
          },
          end: {
            line: 761,
            column: 25
          }
        },
        line: 761
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 33
          },
          end: {
            line: 47,
            column: 63
          }
        }, {
          start: {
            line: 47,
            column: 66
          },
          end: {
            line: 47,
            column: 68
          }
        }],
        line: 47
      },
      "1": {
        loc: {
          start: {
            line: 274,
            column: 39
          },
          end: {
            line: 274,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 274,
            column: 39
          },
          end: {
            line: 274,
            column: 59
          }
        }, {
          start: {
            line: 274,
            column: 63
          },
          end: {
            line: 274,
            column: 72
          }
        }],
        line: 274
      },
      "2": {
        loc: {
          start: {
            line: 281,
            column: 9
          },
          end: {
            line: 281,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 281,
            column: 28
          },
          end: {
            line: 281,
            column: 33
          }
        }],
        line: 281
      },
      "3": {
        loc: {
          start: {
            line: 282,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 282,
            column: 6
          },
          end: {
            line: 282,
            column: 22
          }
        }, {
          start: {
            line: 283,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        }],
        line: 282
      },
      "4": {
        loc: {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 308,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 308,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 299
      },
      "5": {
        loc: {
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 299,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 299,
            column: 8
          },
          end: {
            line: 299,
            column: 29
          }
        }, {
          start: {
            line: 299,
            column: 33
          },
          end: {
            line: 299,
            column: 97
          }
        }],
        line: 299
      },
      "6": {
        loc: {
          start: {
            line: 306,
            column: 26
          },
          end: {
            line: 306,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 306,
            column: 50
          },
          end: {
            line: 306,
            column: 66
          }
        }, {
          start: {
            line: 306,
            column: 69
          },
          end: {
            line: 306,
            column: 70
          }
        }],
        line: 306
      },
      "7": {
        loc: {
          start: {
            line: 319,
            column: 24
          },
          end: {
            line: 319,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 319,
            column: 48
          },
          end: {
            line: 319,
            column: 64
          }
        }, {
          start: {
            line: 319,
            column: 67
          },
          end: {
            line: 319,
            column: 68
          }
        }],
        line: 319
      },
      "8": {
        loc: {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 329,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 328,
            column: 39
          }
        }, {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 65
          }
        }],
        line: 328
      },
      "9": {
        loc: {
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 394,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 394,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 330
      },
      "10": {
        loc: {
          start: {
            line: 330,
            column: 8
          },
          end: {
            line: 330,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 8
          },
          end: {
            line: 330,
            column: 33
          }
        }, {
          start: {
            line: 330,
            column: 37
          },
          end: {
            line: 330,
            column: 68
          }
        }],
        line: 330
      },
      "11": {
        loc: {
          start: {
            line: 332,
            column: 25
          },
          end: {
            line: 332,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 25
          },
          end: {
            line: 332,
            column: 41
          }
        }, {
          start: {
            line: 332,
            column: 45
          },
          end: {
            line: 332,
            column: 47
          }
        }],
        line: 332
      },
      "12": {
        loc: {
          start: {
            line: 346,
            column: 14
          },
          end: {
            line: 348,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 346,
            column: 14
          },
          end: {
            line: 346,
            column: 33
          }
        }, {
          start: {
            line: 347,
            column: 14
          },
          end: {
            line: 347,
            column: 51
          }
        }, {
          start: {
            line: 348,
            column: 14
          },
          end: {
            line: 348,
            column: 43
          }
        }],
        line: 346
      },
      "13": {
        loc: {
          start: {
            line: 352,
            column: 6
          },
          end: {
            line: 366,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 352,
            column: 6
          },
          end: {
            line: 366,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 352
      },
      "14": {
        loc: {
          start: {
            line: 353,
            column: 8
          },
          end: {
            line: 361,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 353,
            column: 8
          },
          end: {
            line: 361,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 353
      },
      "15": {
        loc: {
          start: {
            line: 372,
            column: 8
          },
          end: {
            line: 375,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 372,
            column: 8
          },
          end: {
            line: 375,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 372
      },
      "16": {
        loc: {
          start: {
            line: 372,
            column: 12
          },
          end: {
            line: 372,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 372,
            column: 12
          },
          end: {
            line: 372,
            column: 34
          }
        }, {
          start: {
            line: 372,
            column: 38
          },
          end: {
            line: 372,
            column: 93
          }
        }],
        line: 372
      },
      "17": {
        loc: {
          start: {
            line: 382,
            column: 14
          },
          end: {
            line: 384,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 382,
            column: 14
          },
          end: {
            line: 382,
            column: 35
          }
        }, {
          start: {
            line: 383,
            column: 14
          },
          end: {
            line: 383,
            column: 53
          }
        }, {
          start: {
            line: 384,
            column: 14
          },
          end: {
            line: 384,
            column: 45
          }
        }],
        line: 382
      },
      "18": {
        loc: {
          start: {
            line: 388,
            column: 6
          },
          end: {
            line: 393,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 388,
            column: 6
          },
          end: {
            line: 393,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 388
      },
      "19": {
        loc: {
          start: {
            line: 427,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 427,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 427
      },
      "20": {
        loc: {
          start: {
            line: 427,
            column: 8
          },
          end: {
            line: 427,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 427,
            column: 8
          },
          end: {
            line: 427,
            column: 16
          }
        }, {
          start: {
            line: 427,
            column: 20
          },
          end: {
            line: 427,
            column: 48
          }
        }],
        line: 427
      },
      "21": {
        loc: {
          start: {
            line: 433,
            column: 4
          },
          end: {
            line: 435,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 433,
            column: 4
          },
          end: {
            line: 435,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 433
      },
      "22": {
        loc: {
          start: {
            line: 443,
            column: 20
          },
          end: {
            line: 443,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 443,
            column: 20
          },
          end: {
            line: 443,
            column: 24
          }
        }, {
          start: {
            line: 443,
            column: 28
          },
          end: {
            line: 443,
            column: 66
          }
        }],
        line: 443
      },
      "23": {
        loc: {
          start: {
            line: 444,
            column: 4
          },
          end: {
            line: 446,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 444,
            column: 4
          },
          end: {
            line: 446,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 444
      },
      "24": {
        loc: {
          start: {
            line: 444,
            column: 8
          },
          end: {
            line: 444,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 444,
            column: 8
          },
          end: {
            line: 444,
            column: 16
          }
        }, {
          start: {
            line: 444,
            column: 20
          },
          end: {
            line: 444,
            column: 37
          }
        }],
        line: 444
      },
      "25": {
        loc: {
          start: {
            line: 454,
            column: 4
          },
          end: {
            line: 467,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 455,
            column: 6
          },
          end: {
            line: 459,
            column: 7
          }
        }, {
          start: {
            line: 460,
            column: 6
          },
          end: {
            line: 464,
            column: 7
          }
        }, {
          start: {
            line: 465,
            column: 6
          },
          end: {
            line: 466,
            column: 14
          }
        }],
        line: 454
      },
      "26": {
        loc: {
          start: {
            line: 471,
            column: 5
          },
          end: {
            line: 471,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 471,
            column: 5
          },
          end: {
            line: 471,
            column: 13
          }
        }, {
          start: {
            line: 471,
            column: 17
          },
          end: {
            line: 471,
            column: 19
          }
        }],
        line: 471
      },
      "27": {
        loc: {
          start: {
            line: 474,
            column: 12
          },
          end: {
            line: 474,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 474,
            column: 12
          },
          end: {
            line: 474,
            column: 24
          }
        }, {
          start: {
            line: 474,
            column: 28
          },
          end: {
            line: 474,
            column: 47
          }
        }],
        line: 474
      },
      "28": {
        loc: {
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 484,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 482,
            column: 4
          },
          end: {
            line: 484,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 482
      },
      "29": {
        loc: {
          start: {
            line: 495,
            column: 4
          },
          end: {
            line: 495,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 495,
            column: 4
          },
          end: {
            line: 495,
            column: 42
          }
        }, {
          start: {
            line: 495,
            column: 46
          },
          end: {
            line: 495,
            column: 91
          }
        }],
        line: 495
      },
      "30": {
        loc: {
          start: {
            line: 498,
            column: 4
          },
          end: {
            line: 500,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 498,
            column: 4
          },
          end: {
            line: 500,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 498
      },
      "31": {
        loc: {
          start: {
            line: 504,
            column: 11
          },
          end: {
            line: 504,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 504,
            column: 11
          },
          end: {
            line: 504,
            column: 50
          }
        }, {
          start: {
            line: 504,
            column: 54
          },
          end: {
            line: 504,
            column: 76
          }
        }],
        line: 504
      },
      "32": {
        loc: {
          start: {
            line: 542,
            column: 4
          },
          end: {
            line: 557,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 542,
            column: 4
          },
          end: {
            line: 557,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 542
      },
      "33": {
        loc: {
          start: {
            line: 545,
            column: 8
          },
          end: {
            line: 556,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 546,
            column: 10
          },
          end: {
            line: 555,
            column: 12
          }
        }, {
          start: {
            line: 556,
            column: 12
          },
          end: {
            line: 556,
            column: 16
          }
        }],
        line: 545
      },
      "34": {
        loc: {
          start: {
            line: 569,
            column: 6
          },
          end: {
            line: 571,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 569,
            column: 6
          },
          end: {
            line: 571,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 569
      },
      "35": {
        loc: {
          start: {
            line: 579,
            column: 8
          },
          end: {
            line: 579,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 579,
            column: 8
          },
          end: {
            line: 579,
            column: 37
          }
        }, {
          start: {
            line: 579,
            column: 41
          },
          end: {
            line: 579,
            column: 93
          }
        }],
        line: 579
      },
      "36": {
        loc: {
          start: {
            line: 581,
            column: 6
          },
          end: {
            line: 583,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 581,
            column: 6
          },
          end: {
            line: 583,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 581
      },
      "37": {
        loc: {
          start: {
            line: 581,
            column: 10
          },
          end: {
            line: 581,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 581,
            column: 10
          },
          end: {
            line: 581,
            column: 34
          }
        }, {
          start: {
            line: 581,
            column: 38
          },
          end: {
            line: 581,
            column: 88
          }
        }],
        line: 581
      },
      "38": {
        loc: {
          start: {
            line: 601,
            column: 6
          },
          end: {
            line: 601,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 601,
            column: 6
          },
          end: {
            line: 601,
            column: 21
          }
        }, {
          start: {
            line: 601,
            column: 25
          },
          end: {
            line: 601,
            column: 70
          }
        }],
        line: 601
      },
      "39": {
        loc: {
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 607,
            column: 6
          },
          end: {
            line: 609,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 607
      },
      "40": {
        loc: {
          start: {
            line: 614,
            column: 23
          },
          end: {
            line: 614,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 614,
            column: 50
          },
          end: {
            line: 614,
            column: 60
          }
        }, {
          start: {
            line: 614,
            column: 63
          },
          end: {
            line: 614,
            column: 77
          }
        }],
        line: 614
      },
      "41": {
        loc: {
          start: {
            line: 621,
            column: 9
          },
          end: {
            line: 621,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 621,
            column: 9
          },
          end: {
            line: 621,
            column: 40
          }
        }, {
          start: {
            line: 621,
            column: 44
          },
          end: {
            line: 621,
            column: 57
          }
        }],
        line: 621
      },
      "42": {
        loc: {
          start: {
            line: 650,
            column: 17
          },
          end: {
            line: 659,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 650,
            column: 17
          },
          end: {
            line: 650,
            column: 47
          }
        }, {
          start: {
            line: 651,
            column: 18
          },
          end: {
            line: 658,
            column: 24
          }
        }],
        line: 650
      },
      "43": {
        loc: {
          start: {
            line: 676,
            column: 22
          },
          end: {
            line: 676,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 676,
            column: 22
          },
          end: {
            line: 676,
            column: 34
          }
        }, {
          start: {
            line: 676,
            column: 38
          },
          end: {
            line: 676,
            column: 64
          }
        }],
        line: 676
      },
      "44": {
        loc: {
          start: {
            line: 684,
            column: 17
          },
          end: {
            line: 688,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 684,
            column: 17
          },
          end: {
            line: 684,
            column: 38
          }
        }, {
          start: {
            line: 685,
            column: 18
          },
          end: {
            line: 687,
            column: 35
          }
        }],
        line: 684
      },
      "45": {
        loc: {
          start: {
            line: 686,
            column: 21
          },
          end: {
            line: 686,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 686,
            column: 48
          },
          end: {
            line: 686,
            column: 69
          }
        }, {
          start: {
            line: 686,
            column: 72
          },
          end: {
            line: 686,
            column: 84
          }
        }],
        line: 686
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f4f2d715dc5d043d7f2bb8fe4a3ca13aa3bc245f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_pkh9at0g0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_pkh9at0g0();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_pkh9at0g0().s[0]++, _stylingConstants.default),
  spacing = _ref.spacing,
  mediaQueries = _ref.mediaQueries;
var Wrapper = (cov_pkh9at0g0().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_pkh9at0g0().f[0]++;
    cov_pkh9at0g0().s[2]++;
    return "stx-ProductList g-ProductList-".concat(props.tabMode, " ").concat(props.isHospitalityTab ? (cov_pkh9at0g0().b[0][0]++, 'g-ProductList-HospitalityTab') : (cov_pkh9at0g0().b[0][1]++, ''));
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      > .g-Tabs > .g-Tabs-panel {\n        padding: 0;\n      }\n\n      .g-Tabs-list {\n        text-align: left;\n        padding: 0.5em 6px 0;\n        ", ";\n\n        .g-Tabs-item {\n          margin-left: 0px;\n        }\n      }\n\n      .g-Tabs-link {\n        font-size: 1.1em;\n        padding: 10px;\n        box-sizing: content-box;\n      }\n\n      &.g-ProductList-BLOCK {\n        background-color: ", ";\n\n        .g-Tabs-link {\n          padding: ", " ", ";\n        }\n        .g-Tabs-AdditionalChild {\n          background-color: ", ";\n          padding-bottom: ", ";\n          > div {\n            margin: 0;\n            padding-top: ", ";\n            padding-left: ", ";\n          }\n          .g-ReportFilter-button {\n            border: none;\n          }\n        }\n\n        .g-FilterBar-button-container {\n          margin: 0;\n        }\n\n        .g-FilterBar-InputTextFilter {\n          background: #ffffff;\n        }\n\n        .g-FilterBar-button-container {\n          margin-right: ", ";\n        }\n      }\n\n      &.g-ProductList-HospitalityTab {\n        .g-FilterBar-CollapsiblePanel-Icon {\n          display: none;\n        }\n      }\n\n      .stx-ReportManagement {\n        .g-ReportFilter-button {\n          border: none;\n        }\n      }\n    "])), mediaQueries.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n          padding: 0;\n        "]))), function (props) {
  cov_pkh9at0g0().f[1]++;
  cov_pkh9at0g0().s[3]++;
  return (0, _get.default)(props, 'theme.productList.contentBgColor', '#ffffff');
}, spacing.large, spacing.xlarge, function (props) {
  cov_pkh9at0g0().f[2]++;
  cov_pkh9at0g0().s[4]++;
  return (0, _get.default)(props, 'theme.listFilter.listColor', '#e6e6e6');
}, spacing.large, spacing.large, spacing.xlarge, spacing.xlarge)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      .g-Tabs-list {\n        text-align: left;\n      }\n\n      &.g-ProductList-HospitalityTab {\n        > .g-Tabs {\n          > .g-Tabs-list {\n            background-color: ", ";\n            ", ";\n\n            > .g-Tabs-item {\n              text-align: center;\n\n              &.g-Tabs-item-active {\n                background-color: ", ";\n              }\n\n              :hover {\n                background-color: ", ";\n\n                > .g-Tabs-link {\n                  ::after {\n                    background-color: ", ";\n                  }\n                }\n              }\n\n              ", ";\n\n              > .g-Tabs-link {\n                color: var(--linkTextColor, #0418a4);\n\n                &.is-active {\n                  color: var(--selectedTabTextColor, #0418a4);\n                  ::after {\n                    background-color: ", ";\n                  }\n                }\n              }\n            }\n          }\n\n          > .g-Tabs-AdditionalChild {\n            padding-top: ", "px;\n            padding-bottom: ", "px;\n\n            ", ";\n          }\n\n          > .g-Tabs-panel {\n            padding: 0;\n\n            > .stx-SectionList-SectionsWrapper {\n              border-top-right-radius: 0;\n              border-top-left-radius: 0;\n            }\n          }\n        }\n      }\n\n      > .g-Tabs {\n        > .g-Tabs-list {\n          padding: 0;\n          display: flex;\n\n          > .g-Tabs-item {\n            flex: 1 1 auto;\n            padding: 0;\n\n            > .g-Tabs-link.g-Tabs-link-button {\n              > .g-Button {\n                width: 100%;\n                border-radius: 0;\n              }\n            }\n          }\n        }\n      }\n    "])), function (props) {
  cov_pkh9at0g0().f[3]++;
  cov_pkh9at0g0().s[5]++;
  return (0, _get.default)(props, 'theme.contentBgColor', '#ffffff');
}, (0, _utils.boxShadowOf)('Section', {
  defaultValue: _themeMapper.evolutionTheme.hospitality.tabs.boxShadow
}), _themeMapper.evolutionTheme.hospitality.tabs.active.bgColor, _themeMapper.evolutionTheme.hospitality.tabs.active.bgColor, _themeMapper.evolutionTheme.hospitality.tabs.active.markerColor, _utils.gMediaQueries.md(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n                flex: 1 1 auto;\n              "]))), _themeMapper.evolutionTheme.hospitality.tabs.active.markerColor, _themeMapper.evolutionTheme.spacings.xl, _themeMapper.evolutionTheme.spacings.xl, _utils.gMediaQueries.sm(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n              padding-bottom: 0;\n              background-color: ", ";\n\n              > .g-FilterBar-ToggleWrapper {\n                padding: ", ";\n                padding-top: 0;\n                padding-bottom: 0;\n                margin-bottom: 0;\n              }\n\n              > .g-FilterBar {\n                margin-bottom: var(--focusOutlineWidth);\n                border-radius: 0;\n                box-shadow: none;\n              }\n            "])), function (props) {
  cov_pkh9at0g0().f[4]++;
  cov_pkh9at0g0().s[6]++;
  return (0, _get.default)(props, 'theme.contentBgColor', '#ffffff');
}, _themeMapper.evolutionTheme.filterBar.padding)))));
var Capitalize = (cov_pkh9at0g0().s[7]++, _styledComponents.default.span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  text-transform: uppercase;\n"]))));
var TabFilterBarWrapper = (cov_pkh9at0g0().s[8]++, (0, _styledComponents.default)(_TabFilterBar.default).attrs({
  className: 'g-ProductList-filterBar'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)([""]))));
var noResultsMessageColor = (cov_pkh9at0g0().s[9]++, 'rgb(83, 75, 254)');
var NoResultsTitle = (cov_pkh9at0g0().s[10]++, _styledComponents.default.div.attrs({
  className: 'stx-TicketShopWidget-noResults-title'
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 6px;\n  font-weight: bolder;\n"]))));
var LoadingWrapper = (cov_pkh9at0g0().s[11]++, _styledComponents.default.div.attrs({
  className: 'stx-LoadingWrapper'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n"]))));
var NoResultsWrapper = (cov_pkh9at0g0().s[12]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_message.default).attrs({
  className: 'stx-TicketShopWidget-noResultsContainer'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    padding: 2rem;\n    border: none;\n    color: ", ";\n    .g-Icon {\n      color: ", ";\n    }\n  "])), noResultsMessageColor, noResultsMessageColor)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n    padding: 2rem;\n    border: none;\n    color: var(--messageInfoTitleColor, #6340ae);\n    .g-Icon {\n      color: var(--messageInfoTitleColor, #6340ae);\n    }\n  "]))))));
var EvolutionSectionsWrapper = (cov_pkh9at0g0().s[13]++, _styledComponents.default.section.attrs({
  className: 'stx-SectionList-SectionsWrapper'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n\n  ", ";\n\n  > *:not(:first-child) {\n    margin-top: 16px;\n  }\n"])), _utils.gMediaQueries.md(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n    --borderRadiusValue: var(--generalBorderRadius, 12px);\n    padding: ", " 0;\n    background-color: ", ";\n\n    border-radius: 0 0 var(--borderRadiusValue) var(--borderRadiusValue);\n    theme.sectionBorderRadius || evolutionTheme.productList.borderRadius}\n    ", ";\n    box-shadow: none;\n\n    ", "\n  "])), _themeMapper.evolutionTheme.productList.padding, function (_ref2) {
  var theme = _ref2.theme;
  cov_pkh9at0g0().f[5]++;
  cov_pkh9at0g0().s[14]++;
  return (cov_pkh9at0g0().b[1][0]++, theme.contentBgColor) || (cov_pkh9at0g0().b[1][1]++, '#ffffff');
}, (0, _utils.boxShadowOf)('Section', {
  defaultValue: _themeMapper.evolutionTheme.productList.boxShadow
}), function (_ref3) {
  var _ref3$isHospitalityTa = _ref3.isHospitalityTab,
    isHospitalityTab = _ref3$isHospitalityTa === void 0 ? (cov_pkh9at0g0().b[2][0]++, false) : _ref3$isHospitalityTa;
  cov_pkh9at0g0().f[6]++;
  cov_pkh9at0g0().s[15]++;
  return (cov_pkh9at0g0().b[3][0]++, isHospitalityTab) && (cov_pkh9at0g0().b[3][1]++, (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n        box-shadow: none;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      "]))));
})));
var TabCodesAllowGenerateAllId = (cov_pkh9at0g0().s[16]++, [_productList2.ProductTabEnum.EVENTS, _productList2.ProductTabEnum.VISIT]);
var ProductList = /*#__PURE__*/function (_PureComponent) {
  function ProductList(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ProductList);
    cov_pkh9at0g0().f[9]++;
    cov_pkh9at0g0().s[23]++;
    _this = _callSuper(this, ProductList, [props]);
    (0, _defineProperty2.default)(_this, "onTabChangeHandler", (cov_pkh9at0g0().s[58]++, function (index, tabCode) {
      cov_pkh9at0g0().f[18]++;
      cov_pkh9at0g0().s[59]++;
      _this.setState({
        selectedTabIndex: index
      });
      cov_pkh9at0g0().s[60]++;
      _this.props.onTabChange(tabCode);
    }));
    (0, _defineProperty2.default)(_this, "onFilterApplied", (cov_pkh9at0g0().s[61]++, function (filterCriteria) {
      cov_pkh9at0g0().f[19]++;
      cov_pkh9at0g0().s[62]++;
      // Reset analytic data when filter applied
      _this.setState({
        pushedProductAnalytic: [],
        pushedPromotionAnalytic: []
      }, _this.props.onFilterApplied(filterCriteria));
    }));
    (0, _defineProperty2.default)(_this, "onFilterReset", (cov_pkh9at0g0().s[63]++, function (tabCode) {
      cov_pkh9at0g0().f[20]++;
      cov_pkh9at0g0().s[64]++;
      // Reset analytic data when reset filter
      _this.setState({
        pushedProductAnalytic: [],
        pushedPromotionAnalytic: []
      }, _this.props.onFilterReset(tabCode));
    }));
    (0, _defineProperty2.default)(_this, "getGenerateAllId", (cov_pkh9at0g0().s[65]++, function (tabData) {
      cov_pkh9at0g0().f[21]++;
      cov_pkh9at0g0().s[66]++;
      if ((cov_pkh9at0g0().b[20][0]++, !tabData) || (cov_pkh9at0g0().b[20][1]++, (0, _size.default)(tabData.sections) === 0)) {
        cov_pkh9at0g0().b[19][0]++;
        cov_pkh9at0g0().s[67]++;
        return null;
      } else {
        cov_pkh9at0g0().b[19][1]++;
      }
      var generateAllIds = (cov_pkh9at0g0().s[68]++, tabData.sections.filter(function (section) {
        cov_pkh9at0g0().f[22]++;
        cov_pkh9at0g0().s[69]++;
        return section.generateAllId;
      }).map(function (section) {
        cov_pkh9at0g0().f[23]++;
        cov_pkh9at0g0().s[70]++;
        return section.generateAllId;
      }));
      cov_pkh9at0g0().s[71]++;
      if ((0, _size.default)(generateAllIds) > 0) {
        cov_pkh9at0g0().b[21][0]++;
        cov_pkh9at0g0().s[72]++;
        return generateAllIds[0];
      } else {
        cov_pkh9at0g0().b[21][1]++;
      }
      cov_pkh9at0g0().s[73]++;
      return null;
    }));
    /**
     * Return a set of select product ids of section
     */
    (0, _defineProperty2.default)(_this, "getSelectProductIdsForSection", (cov_pkh9at0g0().s[74]++, function (tabs, tabCode, sectionCode) {
      cov_pkh9at0g0().f[24]++;
      var findTab = (cov_pkh9at0g0().s[75]++, (cov_pkh9at0g0().b[22][0]++, tabs) && (cov_pkh9at0g0().b[22][1]++, tabs.find(function (tab) {
        cov_pkh9at0g0().f[25]++;
        cov_pkh9at0g0().s[76]++;
        return tab.code === tabCode;
      })));
      cov_pkh9at0g0().s[77]++;
      if ((cov_pkh9at0g0().b[24][0]++, !findTab) || (cov_pkh9at0g0().b[24][1]++, !findTab.sections)) {
        cov_pkh9at0g0().b[23][0]++;
        cov_pkh9at0g0().s[78]++;
        return new _set.default();
      } else {
        cov_pkh9at0g0().b[23][1]++;
      }
      var selectProductsIds = (cov_pkh9at0g0().s[79]++, _section.SectionModel.getSelectProducts(findTab.sections, sectionCode).map(function (product) {
        cov_pkh9at0g0().f[26]++;
        cov_pkh9at0g0().s[80]++;
        return product.id;
      }));
      cov_pkh9at0g0().s[81]++;
      return new _set.default(selectProductsIds);
    }));
    (0, _defineProperty2.default)(_this, "updateState", (cov_pkh9at0g0().s[82]++, function (items, itemType) {
      cov_pkh9at0g0().f[27]++;
      cov_pkh9at0g0().s[83]++;
      switch (itemType) {
        case 'PRODUCT':
          cov_pkh9at0g0().b[25][0]++;
          {
            var pushedProductAnalytic = (cov_pkh9at0g0().s[84]++, [].concat((0, _toConsumableArray2.default)(_this.state.pushedProductAnalytic), (0, _toConsumableArray2.default)(items)));
            cov_pkh9at0g0().s[85]++;
            _this.setState({
              pushedProductAnalytic: pushedProductAnalytic
            });
            cov_pkh9at0g0().s[86]++;
            break;
          }
        case 'PROMOTION':
          cov_pkh9at0g0().b[25][1]++;
          {
            var pushedPromotionAnalytic = (cov_pkh9at0g0().s[87]++, [].concat((0, _toConsumableArray2.default)(_this.state.pushedPromotionAnalytic), (0, _toConsumableArray2.default)(items)));
            cov_pkh9at0g0().s[88]++;
            _this.setState({
              pushedPromotionAnalytic: pushedPromotionAnalytic
            });
            cov_pkh9at0g0().s[89]++;
            break;
          }
        default:
          cov_pkh9at0g0().b[25][2]++;
          cov_pkh9at0g0().s[90]++;
          break;
      }
    }));
    (0, _defineProperty2.default)(_this, "toMainProductsForReport", (cov_pkh9at0g0().s[91]++, function (products) {
      cov_pkh9at0g0().f[28]++;
      cov_pkh9at0g0().s[92]++;
      return ((cov_pkh9at0g0().b[26][0]++, products) || (cov_pkh9at0g0().b[26][1]++, [])).map(function (product) {
        cov_pkh9at0g0().f[29]++;
        cov_pkh9at0g0().s[93]++;
        return {
          id: product.id,
          name: product.name,
          type: (cov_pkh9at0g0().b[27][0]++, product.type) || (cov_pkh9at0g0().b[27][1]++, product.productType)
        };
      });
    }));
    /**
     * Return object ReportData with more data for section
     */
    (0, _defineProperty2.default)(_this, "buildReportDataForSection", (cov_pkh9at0g0().s[94]++, function (tabCode, sectionCode, reportData, productList) {
      cov_pkh9at0g0().f[30]++;
      cov_pkh9at0g0().s[95]++;
      // Not pass report report data for tab Tour
      if (tabCode === _productList2.ProductTabEnum.TOURS) {
        cov_pkh9at0g0().b[28][0]++;
        cov_pkh9at0g0().s[96]++;
        return {};
      } else {
        cov_pkh9at0g0().b[28][1]++;
      }
      cov_pkh9at0g0().s[97]++;
      return _objectSpread(_objectSpread({}, reportData), {}, {
        selectProductIds: _this.getSelectProductIdsForSection(productList.tabs, tabCode, sectionCode),
        // Pass tab and section code to action update when product id is selected
        onProductSelectChange: function onProductSelectChange(productId, isSelectAll) {
          cov_pkh9at0g0().f[31]++;
          cov_pkh9at0g0().s[98]++;
          return reportData.onProductSelectChange(tabCode, sectionCode, productId, isSelectAll);
        }
      });
    }));
    (0, _defineProperty2.default)(_this, "isHospitalityTab", (cov_pkh9at0g0().s[99]++, function (tabCode) {
      cov_pkh9at0g0().f[32]++;
      cov_pkh9at0g0().s[100]++;
      return (cov_pkh9at0g0().b[29][0]++, tabCode === _productList2.ProductTabEnum.HOSPITALITY) || (cov_pkh9at0g0().b[29][1]++, tabCode === _productList2.ProductTabEnum.HOSPITALITY_BUNDLE);
    }));
    (0, _defineProperty2.default)(_this, "isHospitalityProducts", (cov_pkh9at0g0().s[101]++, function (products) {
      cov_pkh9at0g0().f[33]++;
      cov_pkh9at0g0().s[102]++;
      if (products.length === 0) {
        cov_pkh9at0g0().b[30][0]++;
        cov_pkh9at0g0().s[103]++;
        return false;
      } else {
        cov_pkh9at0g0().b[30][1]++;
      }
      var product = (cov_pkh9at0g0().s[104]++, products[products.length - 1]);
      // Hospitality is special case, we set sectionCode and tabCode equal to an id and position equal to 0 when get data from nucleo.
      // TODO: find better solution.
      cov_pkh9at0g0().s[105]++;
      return (cov_pkh9at0g0().b[31][0]++, product.tabCode === product.sectionCode) && (cov_pkh9at0g0().b[31][1]++, product.position === 0);
    }));
    var _ref4 = (cov_pkh9at0g0().s[24]++, props),
      _productList = _ref4.productList,
      defaultTab = _ref4.defaultTab;
    var selectedTabIndex = (cov_pkh9at0g0().s[25]++, (0, _values.default)(_productList.tabs).findIndex(function (tab) {
      cov_pkh9at0g0().f[10]++;
      cov_pkh9at0g0().s[26]++;
      return tab.code === defaultTab;
    }));
    cov_pkh9at0g0().s[27]++;
    _this.state = {
      selectedTabIndex: selectedTabIndex > -1 ? (cov_pkh9at0g0().b[7][0]++, selectedTabIndex) : (cov_pkh9at0g0().b[7][1]++, 0),
      // list of product ids and promotion ids that have been pushed to datalayer
      pushedProductAnalytic: [],
      pushedPromotionAnalytic: []
    };
    return _this;
  }
  (0, _inherits2.default)(ProductList, _PureComponent);
  return (0, _createClass2.default)(ProductList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      cov_pkh9at0g0().f[11]++;
      var useGoogleEnhancedTracking = (cov_pkh9at0g0().s[28]++, (cov_pkh9at0g0().b[8][0]++, prevProps.ecommerceGoogleTracking) && (cov_pkh9at0g0().b[8][1]++, prevProps.ecommerceGoogleTracking.useGoogleEnhancedTracking));
      cov_pkh9at0g0().s[29]++;
      if ((cov_pkh9at0g0().b[10][0]++, useGoogleEnhancedTracking) && (cov_pkh9at0g0().b[10][1]++, !(0, _isEqual.default)(prevProps, this.props))) {
        cov_pkh9at0g0().b[9][0]++;
        var _ref5 = (cov_pkh9at0g0().s[30]++, prevProps.ecommerceGoogleTracking),
          user = _ref5.user,
          useGA4 = _ref5.useGA4;
        cov_pkh9at0g0().s[31]++;
        window.dataLayer = (cov_pkh9at0g0().b[11][0]++, window.dataLayer) || (cov_pkh9at0g0().b[11][1]++, []);
        var _ref6 = (cov_pkh9at0g0().s[32]++, this.state),
          selectedTabIndex = _ref6.selectedTabIndex;
        var tabs = (cov_pkh9at0g0().s[33]++, (0, _get.default)(this.props, 'productList.tabs', []));
        var dataAnalytic = (cov_pkh9at0g0().s[34]++, (0, _get.default)(this.props, 'productList.analyticData', {
          products: [],
          promotions: []
        }));
        var _ref7 = (cov_pkh9at0g0().s[35]++, dataAnalytic),
          products = _ref7.products,
          promotions = _ref7.promotions;

        // Using prevState to filter pushed product, in case applying filter - we reset the pushed analytic data.
        var productsToPush = (cov_pkh9at0g0().s[36]++, products.filter(function (product) {
          cov_pkh9at0g0().f[12]++;
          cov_pkh9at0g0().s[37]++;
          return !prevState.pushedProductAnalytic.some(function (p) {
            cov_pkh9at0g0().f[13]++;
            cov_pkh9at0g0().s[38]++;
            return (cov_pkh9at0g0().b[12][0]++, p.id === product.id) && (cov_pkh9at0g0().b[12][1]++, p.sectionCode === product.sectionCode) && (cov_pkh9at0g0().b[12][2]++, p.tabCode === product.tabCode);
          });
        }));
        cov_pkh9at0g0().s[39]++;
        if ((0, _size.default)(productsToPush) > 0) {
          cov_pkh9at0g0().b[13][0]++;
          cov_pkh9at0g0().s[40]++;
          if (this.isHospitalityProducts(productsToPush)) {
            cov_pkh9at0g0().b[14][0]++;
            // For HOSPITALITY products, we set its positions here.
            var position = (cov_pkh9at0g0().s[41]++, 0);
            cov_pkh9at0g0().s[42]++;
            productsToPush.forEach(function (product) {
              cov_pkh9at0g0().f[14]++;
              cov_pkh9at0g0().s[43]++;
              // eslint-disable-next-line no-param-reassign
              product.position = position;
              cov_pkh9at0g0().s[44]++;
              position += 1;
            });
          } else {
            cov_pkh9at0g0().b[14][1]++;
          }
          cov_pkh9at0g0().s[45]++;
          window.dataLayer.push(_helper.DataAnalyticHelper.getProductImpression(productsToPush, user, useGA4));
          cov_pkh9at0g0().s[46]++;
          this.updateState(productsToPush, 'PRODUCT');
        } else {
          cov_pkh9at0g0().b[13][1]++;
        }

        // Because promotions may not in consecutive order, we have to set its position in this step.
        // Set position for promotions in same tab.
        var promotionPosition = (cov_pkh9at0g0().s[47]++, 0);
        cov_pkh9at0g0().s[48]++;
        (0, _keys.default)(promotions).forEach(function (key) {
          cov_pkh9at0g0().f[15]++;
          cov_pkh9at0g0().s[49]++;
          if ((cov_pkh9at0g0().b[16][0]++, tabs[selectedTabIndex]) && (cov_pkh9at0g0().b[16][1]++, tabs[selectedTabIndex].code === promotions[key].tabCode)) {
            cov_pkh9at0g0().b[15][0]++;
            cov_pkh9at0g0().s[50]++;
            promotions[key].position = (0, _parseInt2.default)(promotionPosition, 10);
            cov_pkh9at0g0().s[51]++;
            promotionPosition += 1;
          } else {
            cov_pkh9at0g0().b[15][1]++;
          }
        });
        var promotionsToPush = (cov_pkh9at0g0().s[52]++, promotions.filter(function (promotion) {
          cov_pkh9at0g0().f[16]++;
          cov_pkh9at0g0().s[53]++;
          return !_this2.state.pushedPromotionAnalytic.some(function (p) {
            cov_pkh9at0g0().f[17]++;
            cov_pkh9at0g0().s[54]++;
            return (cov_pkh9at0g0().b[17][0]++, p.id === promotion.id) && (cov_pkh9at0g0().b[17][1]++, p.sectionCode === promotion.sectionCode) && (cov_pkh9at0g0().b[17][2]++, p.tabCode === promotion.tabCode);
          });
        }));
        cov_pkh9at0g0().s[55]++;
        if ((0, _size.default)(promotionsToPush) > 0) {
          cov_pkh9at0g0().b[18][0]++;
          cov_pkh9at0g0().s[56]++;
          window.dataLayer.push(_helper.DataAnalyticHelper.getPromotionImpression(promotionsToPush, user, useGA4));
          cov_pkh9at0g0().s[57]++;
          this.updateState(promotionsToPush, 'PROMOTION');
        } else {
          cov_pkh9at0g0().b[18][1]++;
        }
      } else {
        cov_pkh9at0g0().b[9][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_pkh9at0g0().f[34]++;
      var _ref8 = (cov_pkh9at0g0().s[106]++, this.props),
        productList = _ref8.productList,
        aspectRatio = _ref8.aspectRatio,
        waitingListEnabled = _ref8.waitingListEnabled,
        currencyCode = _ref8.currencyCode,
        isSignedIn = _ref8.isSignedIn,
        onLoadMore = _ref8.onLoadMore,
        onAdvantageValueEntered = _ref8.onAdvantageValueEntered,
        maxItemPerSection = _ref8.maxItemPerSection,
        displayActionBtn = _ref8.displayActionBtn,
        columns = _ref8.columns,
        filter = _ref8.filter,
        showPastDatesOnFilter = _ref8.showPastDatesOnFilter,
        tabMode = _ref8.tabMode,
        reportData = _ref8.reportData,
        isLoading = _ref8.isLoading,
        ecommerceGoogleTracking = _ref8.ecommerceGoogleTracking,
        useMainTitleBackgroundColor = _ref8.useMainTitleBackgroundColor,
        resaleAvailability = _ref8.resaleAvailability,
        themeQueries = _ref8.themeQueries,
        currentTheme = _ref8.currentTheme;
      var tabs = (cov_pkh9at0g0().s[107]++, productList.tabs);
      var _ref9 = (cov_pkh9at0g0().s[108]++, this.state),
        selectedTabIndex = _ref9.selectedTabIndex;
      var currentTabCode = (cov_pkh9at0g0().s[109]++, tabs[selectedTabIndex].code);
      var advantageCode = (cov_pkh9at0g0().s[110]++, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
        my: 2,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 536,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_advantageCode.default, {
        onValueSubmit: onAdvantageValueEntered,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 537,
          columnNumber: 9
        }
      })));
      var filterWrapper = (cov_pkh9at0g0().s[111]++, null);
      cov_pkh9at0g0().s[112]++;
      if (filter) {
        cov_pkh9at0g0().b[32][0]++;
        var _ref10 = (cov_pkh9at0g0().s[113]++, tabs[selectedTabIndex]),
          arrFilters = _ref10.arrFilters,
          code = _ref10.code;
        cov_pkh9at0g0().s[114]++;
        filterWrapper = (0, _size.default)(arrFilters) > 0 ? (cov_pkh9at0g0().b[33][0]++, /*#__PURE__*/_react.default.createElement(TabFilterBarWrapper, {
          filter: filter,
          onFilterApplied: this.onFilterApplied,
          onFilterReset: this.onFilterReset,
          currencyCode: currencyCode,
          arrFilters: arrFilters,
          currentTabCode: code,
          showPastDates: showPastDatesOnFilter,
          showToggle: this.isHospitalityTab(currentTabCode),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 546,
            columnNumber: 11
          }
        })) : (cov_pkh9at0g0().b[33][1]++, null);
      } else {
        cov_pkh9at0g0().b[32][1]++;
      }
      var _ref11 = (cov_pkh9at0g0().s[115]++, reportData),
        isReportContext = _ref11.isReportContext,
        reportVariants = _ref11.reportVariants,
        seasonId = _ref11.seasonId,
        reportGenerateUrl = _ref11.reportGenerateUrl,
        requestConfig = _ref11.requestConfig;
      cov_pkh9at0g0().s[116]++;
      var reportManagement = function reportManagement(tabCode) {
        cov_pkh9at0g0().f[35]++;
        cov_pkh9at0g0().s[117]++;
        // Not display report management for tab Tour
        if (tabCode === _productList2.ProductTabEnum.TOURS) {
          cov_pkh9at0g0().b[34][0]++;
          cov_pkh9at0g0().s[118]++;
          return null;
        } else {
          cov_pkh9at0g0().b[34][1]++;
        }
        var generateAllId = (cov_pkh9at0g0().s[119]++, null);
        var selectProductsOfTab = (cov_pkh9at0g0().s[120]++, _productList2.ProductListModel.getSelectProductsOfTab(productList.tabs, tabCode));
        var allProductsOfTab = (cov_pkh9at0g0().s[121]++, _productList2.ProductListModel.getRawProductsOfTab(productList.tabs, tabCode));
        var isAllProductWereSelected = (cov_pkh9at0g0().s[122]++, (cov_pkh9at0g0().b[35][0]++, (0, _size.default)(selectProductsOfTab) > 0) && (cov_pkh9at0g0().b[35][1]++, (0, _size.default)(selectProductsOfTab) === (0, _size.default)(allProductsOfTab)));
        // STX-98580: just support generate all id for EVENT + VISIT tab
        cov_pkh9at0g0().s[123]++;
        if ((cov_pkh9at0g0().b[37][0]++, isAllProductWereSelected) && (cov_pkh9at0g0().b[37][1]++, TabCodesAllowGenerateAllId.indexOf(tabCode) !== -1)) {
          cov_pkh9at0g0().b[36][0]++;
          cov_pkh9at0g0().s[124]++;
          generateAllId = _this3.getGenerateAllId(productList.tabs.find(function (tab) {
            cov_pkh9at0g0().f[36]++;
            cov_pkh9at0g0().s[125]++;
            return tab.code === tabCode;
          }));
        } else {
          cov_pkh9at0g0().b[36][1]++;
        }
        cov_pkh9at0g0().s[126]++;
        return /*#__PURE__*/_react.default.createElement(_reportManagement.default, {
          reportGenerateUrl: reportGenerateUrl,
          reportVariants: reportVariants,
          seasonId: seasonId,
          isDisable: (0, _size.default)(selectProductsOfTab) === 0,
          mainProducts: _this3.toMainProductsForReport(selectProductsOfTab),
          isAllProductsWereSelected: isAllProductWereSelected,
          generateAllId: generateAllId,
          requestConfig: requestConfig,
          isGenerateProductLevel: true,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 585,
            columnNumber: 9
          }
        });
      };
      var additionalChildOfTabs = (cov_pkh9at0g0().s[127]++, [filterWrapper, (cov_pkh9at0g0().b[38][0]++, isReportContext) && (cov_pkh9at0g0().b[38][1]++, reportManagement(tabs[selectedTabIndex].code))]);
      var tabType = (cov_pkh9at0g0().s[128]++, 'text');
      var SectionsWrapper = (cov_pkh9at0g0().s[129]++, function () {
        cov_pkh9at0g0().f[37]++;
        cov_pkh9at0g0().s[130]++;
        if (themeQueries.EVOLUTION) {
          cov_pkh9at0g0().b[39][0]++;
          cov_pkh9at0g0().s[131]++;
          return EvolutionSectionsWrapper;
        } else {
          cov_pkh9at0g0().b[39][1]++;
        }
        cov_pkh9at0g0().s[132]++;
        return _react.default.Fragment;
      }());
      var TabWrapper = (cov_pkh9at0g0().s[133]++, themeQueries.EQUILIBRIUM ? (cov_pkh9at0g0().b[40][0]++, Capitalize) : (cov_pkh9at0g0().b[40][1]++, _react.default.Fragment));
      cov_pkh9at0g0().s[134]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        currentTheme: currentTheme,
        tabMode: tabMode,
        isHospitalityTab: this.isHospitalityTab(currentTabCode),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 617,
          columnNumber: 7
        }
      }, (cov_pkh9at0g0().b[41][0]++, this.props.showAdvantageCodeBar) && (cov_pkh9at0g0().b[41][1]++, advantageCode), /*#__PURE__*/_react.default.createElement(_tabs.Tabs, {
        tabType: tabType,
        useGoogleEnhancedTracking: ecommerceGoogleTracking.useGoogleEnhancedTracking,
        selectedTabIndex: selectedTabIndex,
        onTabsChange: this.onTabChangeHandler,
        additionalChild: additionalChildOfTabs,
        centered: true,
        noBorder: themeQueries.EQUILIBRIUM,
        useMainTitleBackgroundColor: useMainTitleBackgroundColor,
        tabMode: tabMode,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 622,
          columnNumber: 9
        }
      }, tabs.map(function (tab, idx) {
        cov_pkh9at0g0().f[38]++;
        cov_pkh9at0g0().s[135]++;
        return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
          tabType: tabType,
          buttonProps: {
            variant: _button.ButtonVariant.tertiary,
            outline: false,
            active: {
              variant: _button.ButtonVariant.secondary
            }
          },
          key: tab.code,
          label: /*#__PURE__*/_react.default.createElement(TabWrapper, {
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 644,
              columnNumber: 17
            }
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: "gravity.ProductList.tab.".concat(tab.code),
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 645,
              columnNumber: 19
            }
          })),
          active: selectedTabIndex === idx,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 633,
            columnNumber: 13
          }
        }, /*#__PURE__*/_react.default.createElement(SectionsWrapper, {
          isHospitalityTab: _this3.isHospitalityTab(currentTabCode),
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 649,
            columnNumber: 15
          }
        }, (cov_pkh9at0g0().b[42][0]++, (0, _helper.isTabEmptyData)(tab, isLoading)) && (cov_pkh9at0g0().b[42][1]++, /*#__PURE__*/_react.default.createElement("div", {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 651,
            columnNumber: 19
          }
        }, /*#__PURE__*/_react.default.createElement(NoResultsWrapper, {
          status: _message.MessageStatus.INFO,
          iconSize: 'xlarge',
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 652,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement(NoResultsTitle, {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 653,
            columnNumber: 23
          }
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.TicketShop.information",
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 654,
            columnNumber: 25
          }
        })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.TicketShop.noProductsAvailable",
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 656,
            columnNumber: 23
          }
        })))), tab.sections.map(function (section) {
          cov_pkh9at0g0().f[39]++;
          cov_pkh9at0g0().s[136]++;
          return /*#__PURE__*/_react.default.createElement(_SectionProducts.default, {
            filter: filter,
            key: section.code,
            section: section,
            tab: tab,
            maxItemPerSection: maxItemPerSection,
            currencyCode: currencyCode,
            waitingListEnabled: waitingListEnabled,
            isSignedIn: isSignedIn,
            aspectRatio: aspectRatio,
            onLoadMore: onLoadMore,
            displayActionBtn: displayActionBtn,
            columns: columns,
            reportData: _this3.buildReportDataForSection(tab.code, (cov_pkh9at0g0().b[43][0]++, section.code) || (cov_pkh9at0g0().b[43][1]++, _section.SectionCodeEnum.ALL_EVENTS), reportData, productList),
            ecommerceGoogleTracking: ecommerceGoogleTracking,
            resaleAvailability: resaleAvailability,
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 661,
              columnNumber: 19
            }
          });
        }), (cov_pkh9at0g0().b[44][0]++, (0, _helper.isTabInitLoading)(tab)) && (cov_pkh9at0g0().b[44][1]++, /*#__PURE__*/_react.default.createElement(LoadingWrapper, {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 685,
            columnNumber: 19
          }
        }, themeQueries.EQUILIBRIUM ? (cov_pkh9at0g0().b[45][0]++, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 686,
            columnNumber: 49
          }
        })) : (cov_pkh9at0g0().b[45][1]++, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 686,
            columnNumber: 73
          }
        }))))));
      })));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(ProductList, "getDerivedStateFromProps", (cov_pkh9at0g0().s[17]++, function (nextProps, state) {
  cov_pkh9at0g0().f[7]++;
  cov_pkh9at0g0().s[18]++;
  if ((cov_pkh9at0g0().b[5][0]++, nextProps.productList) && (cov_pkh9at0g0().b[5][1]++, nextProps.productList.tabs[state.selectedTabIndex] === undefined)) {
    cov_pkh9at0g0().b[4][0]++;
    // Should recalculate selected index, this case happened after we filter tab with no available section
    var selectedTabIndex = (cov_pkh9at0g0().s[19]++, (0, _values.default)(nextProps.productList.tabs).findIndex(function (tab) {
      cov_pkh9at0g0().f[8]++;
      cov_pkh9at0g0().s[20]++;
      return tab.code === nextProps.defaultTab;
    }));
    cov_pkh9at0g0().s[21]++;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedTabIndex: selectedTabIndex > -1 ? (cov_pkh9at0g0().b[6][0]++, selectedTabIndex) : (cov_pkh9at0g0().b[6][1]++, 0)
    });
  } else {
    cov_pkh9at0g0().b[4][1]++;
  }
  cov_pkh9at0g0().s[22]++;
  return null;
}));
cov_pkh9at0g0().s[137]++;
ProductList.propTypes = {
  /* The product list object, containing a list of sections */
  productList: _productList2.ProductListType.isRequired,
  /* The choosen tab by default */
  defaultTab: _propTypes.default.oneOf((0, _values.default)(_productList2.ProductTabEnum)).isRequired,
  /* function to handle change tab event */
  onTabChange: _propTypes.default.func.isRequired,
  /* function to handle load more product per section event */
  onLoadMore: _propTypes.default.func.isRequired,
  /* function to handle entered advantage code */
  onAdvantageValueEntered: _propTypes.default.func.isRequired,
  /* maximum product items per section */
  maxItemPerSection: _propTypes.default.number,
  /* The needed currency to display prices */
  currencyCode: _propTypes.default.string.isRequired,
  /* Define if waiting list for product not yet in sales is opened */
  waitingListEnabled: _propTypes.default.bool,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /**
   * The Aspect ratio for the image.
   */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /** The function called when filter criteria have changed */
  onFilterApplied: _propTypes.default.func.isRequired,
  /** The function called when filter has been reset */
  onFilterReset: _propTypes.default.func.isRequired,
  /** True if we want to display past dates in the date filter  */
  showPastDatesOnFilter: _propTypes.default.bool,
  /** Option to display action button  */
  displayActionBtn: _propTypes.default.bool,
  /** Number of product columns on a row */
  columns: _propTypes.default.number,
  /** the filter data */
  filter: _propTypes.default.shape(_filter.FilterType).isRequired,
  /** False to hide the advantage code bar */
  showAdvantageCodeBar: _propTypes.default.bool,
  /** The design of the tabs. FLAT is more fresh and modern. BLOCK is more prominent. */
  tabMode: _propTypes.default.oneOf(['FLAT', 'BLOCK']),
  /* Contain data for handle display and action for report management */
  reportData: _propTypes.default.shape(_productList2.ReportManagementDataType),
  /* True if data is loading - Using for check between empty data and data still loading */
  isLoading: _propTypes.default.bool,
  /* Enable Google Tag Manager */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /* True to set a background color of tabs same as pos theme config */
  useMainTitleBackgroundColor: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  /** theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_pkh9at0g0().s[138]++;
ProductList.defaultProps = {
  showSeeAllButton: false,
  seeAllButtonUrl: null,
  waitingListEnabled: false,
  isSignedIn: false,
  maxItemPerSection: 10,
  aspectRatio: 'WIDE',
  columns: 3,
  displayActionBtn: true,
  onFilterApplied: function onFilterApplied() {
    cov_pkh9at0g0().f[40]++;
  },
  onFilterReset: function onFilterReset() {
    cov_pkh9at0g0().f[41]++;
  },
  filter: {},
  showPastDatesOnFilter: false,
  showAdvantageCodeBar: true,
  tabMode: 'FLAT',
  reportData: {},
  isLoading: false,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  useMainTitleBackgroundColor: false,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _styledComponents.withTheme)(ProductList)));